import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// Unregister CRA service worker so sitemap.xml / robots.txt are not
// intercepted and rewritten to index.html in the browser.
unregisterServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js